var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-pagination',{attrs:{"page-sizes":[20, 50, 100, 200, 400, 500, 1000],"page-size":20,"layout":"sizes, prev, pager, next","total":1000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }